<div *ngIf="activity">
  <mat-toolbar class="mat-primary">
    <span *ngIf="activity.type == 'EMAIL_ACTIVITY'" fxFlex>E-Mail gesendet</span>
    <span *ngIf="activity.type == 'AUDIT_ACTIVITY' && !activity.stateTo" fxFlex>Audit Informationen</span>
    <span *ngIf="activity.type == 'AUDIT_ACTIVITY' && activity.stateTo && activity.stateFrom" fxFlex>
      Statuswechsel
    </span>
    <span *ngIf="activity.type == 'AUDIT_ACTIVITY' && activity.stateTo && !activity.stateFrom" fxFlex>
      durchgeführte Aktion
    </span>
    <mat-icon class="cursor-mat-element" (click)="cancel()">close</mat-icon>
  </mat-toolbar>
  <mat-dialog-content style="padding: 4rem">
    <div *ngIf="activity.type == 'EMAIL_ACTIVITY'" flex fxLayout="column" fxLayoutAlign="center">
      Erstellt von:
      <p id="onTop" style="font-weight: bold">
        {{ activity.createdBy === 'anonymousUser' ? 'Automatisch erzeugte E-Mail' : activity.createdBy }}
      </p>
      Betreff:
      <p id="onTop" style="font-weight: bold">{{ activity.subject }}</p>
      Empfänger:
      <p style="font-weight: bold">{{ activity.recipient }}</p>
      E-Mail:
      <p [innerHTML]="activity.body | safeHtmlPipe"></p>
    </div>

    <div *ngIf="activity.type == 'AUDIT_ACTIVITY'" flex fxLayout="column" fxLayoutAlign="center">
      <div *ngIf="activity.stateTo">
        <div>Änderung</div>
        <p style="font-weight: bold">
          {{ activity.createdDate | date : 'dd.MM.yy, H:mm' }} ({{ activity.createdBy | userActivity }})
        </p>
        <div>Vorstatus</div>
        <p style="font-weight: bold">
          {{ activity.stateFrom | statusEntityAuditActivity : activity.statusModule }}
        </p>
        <div>Neuer Status</div>
        <p style="font-weight: bold">
          {{ activity.stateTo | statusEntityAuditActivity : activity.statusModule }}
        </p>
      </div>
      <div *ngIf="activity.information">
        <div *ngIf="!activity.stateTo">Information</div>
        <div *ngIf="activity.stateTo">Kommentar</div>
        <p style="font-weight: bold" [innerHTML]="activity.information | safeHtmlPipe"></p>
      </div>
    </div>

    <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
      <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">
        Abbrechen
      </button>
    </div>
  </mat-dialog-content>
</div>
